import { Outlet, Link } from 'react-router-dom';
import Header from './Header';
import RealtimeNotifier from './RealtimeNotifier';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col th-bg transition-colors duration-300">
      <RealtimeNotifier />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t th-border transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-wrap gap-8 justify-between font-mono text-[10px] uppercase tracking-[0.18em] th-text-muted">
          <div>
            <div className="th-text font-bold mb-2.5 tracking-[0.15em]">STRIDERR</div>
            Booking underground.
            <br />
            Paris · Berlin · Bruxelles.
          </div>
          <nav className="flex flex-col gap-2">
            <Link to="/artists" className="th-text-secondary hover:text-accent transition-colors duration-150">
              Artistes
            </Link>
            <Link to="/register" className="th-text-secondary hover:text-accent transition-colors duration-150">
              Devenir membre
            </Link>
            <Link to="/login" className="th-text-secondary hover:text-accent transition-colors duration-150">
              Connexion
            </Link>
          </nav>
          <div className="text-right">
            © 2026 · Tous droits réservés
            <br />
            No logo / no hype.
          </div>
        </div>
      </footer>
    </div>
  );
}
